import Grid from '@mui/material/GridLegacy';
import Typography from '@mui/material/Typography';
import classnames from 'classnames';
import React from 'react';
import { withStyles } from '../../styles/tools';
import { withTrace } from '../../utils/trace';
import { styles } from './EmptyState.styles';
export function EmptyStateBase({ classes, children, image, title, message, variant = 'large', applyTrace, }) {
    const isSmall = variant === 'small';
    return (React.createElement(Grid, Object.assign({ container: true, justifyContent: "center", alignItems: "center", className: classes.root }, applyTrace()),
        image && (React.createElement(Grid, Object.assign({ item: true, xs: 12 }, applyTrace('image')), image)),
        React.createElement(Grid, { item: true, xs: 12, sm: isSmall ? 10 : 6, md: isSmall ? 10 : 4, className: classes.body },
            React.createElement(Typography, Object.assign({ className: classnames(classes.title, { [classes.smallTitle]: isSmall }) }, applyTrace('title')), title),
            React.createElement(Typography, Object.assign({ className: classes.message }, applyTrace('message')), message),
            children && React.createElement(Grid, Object.assign({}, applyTrace('children')), children))));
}
const tracedComponent = withTrace('empty-state')(EmptyStateBase);
export const EmptyState = withStyles(styles)(tracedComponent);
export default EmptyState;
//# sourceMappingURL=EmptyState.js.map